import { GroupMode, RouteOrderByField } from '@bringg/types';

import { isTwoLevelsGroup } from '../../shared/utils/grouping';
import { loaderPageCreator } from '../../shared/data/loader-page-creator';
import { orderExplorerRootStore } from 'bringg-web/features/monitoring/order-explorer/stores/order-explorer-root-store';
import { monitoringFiltersProvider } from '../../shared/components/monitoring-filter-bar/utils/monitoring-filter-provider';
import { orderExplorerLoader } from 'bringg-web/features/monitoring/order-explorer/data/order-explorer-loader';
import { orderExplorerGroupLoader } from 'bringg-web/features/monitoring/order-explorer/data/order-explorer-group-loader';
import { MAX_TEAM_LIMIT } from '../../shared/components/team-selector/team-selector';

async function load() {
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;

	if (orderExplorerStore.loading) {
		orderExplorerStore.refreshAC.abort();
		orderExplorerStore.refreshAC = new AbortController();
	}
	orderExplorerStore.loading = true;

	const { itemsByGroup, groupMode, sorting, filters, groups, entityType } = orderExplorerStore.currentTableDefinition;

	if (!Object.keys(itemsByGroup).length) {
		orderExplorerStore.setInitialLoading(true);
	}

	try {
		const page = loaderPageCreator.create(groups, itemsByGroup, entityType);

		const taskRequest = {
			grouping: groupMode,
			sorting: sorting,
			filters: monitoringFiltersProvider.mapFiltersToServer(filters.task),
			page: page,
			collapsed_groups: [],
			entity_type: orderExplorerStore.currentTableDefinition.entityType,
			route_order_by_field: RouteOrderByField.StartTime
		};

		const requests = [taskRequest];

		if (isTwoLevelsGroup(groupMode) || groupMode === GroupMode.Team) {
			requests.push({
				...taskRequest,
				entity_type: isTwoLevelsGroup(groupMode) ? 'top_level_group' : 'task_group',
				page: { limit: MAX_TEAM_LIMIT, from: undefined }
			});
		}

		const response = await orderExplorerLoader.load(
			{ query_requests: requests },
			{ signal: orderExplorerStore.disposeSignal }
		);

		orderExplorerStore.setResponse(response, false);

		await orderExplorerGroupLoader.completeLastGroup();
	} catch (e) {
		orderExplorerStore.currentTableDefinition.setHasMoreData();
		console.error('failed to fetch order explorer data ', e);
	} finally {
		orderExplorerStore.setLoading(false);
		orderExplorerStore.setInitialLoading(false);
	}
}

export const orderExplorerPageLoader = { load };
